var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecruiters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 513372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99609 16.4074L10.1524 13.8199C11.0068 12.7946 11.434 12.2818 11.9961 12.2818C12.5581 12.2818 12.9853 12.7946 13.8399 13.8199L14.1523 14.195C15.0069 15.2203 15.4341 15.733 15.9961 15.733C16.5581 15.733 16.9854 15.2203 17.8398 14.195L19.9961 11.6074",
    stroke: "#426CFF",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.9961 14C25.9961 19.6568 25.9961 22.4853 24.2387 24.2426C22.4814 26 19.6529 26 13.9961 26C8.33923 26 5.51081 26 3.75346 24.2426C1.99609 22.4853 1.99609 19.6568 1.99609 14C1.99609 8.34314 1.99609 5.51472 3.75346 3.75736C5.51081 2 8.33923 2 13.9961 2C19.6529 2 22.4814 2 24.2387 3.75736C25.4073 4.92585 25.7988 6.56786 25.93 9.2",
    stroke: "#426CFF",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1243",
    cx: 25.0675,
    cy: 25.0714,
    r: 6.07143,
    fill: "#43C3FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 513375"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 168",
    x1: 21.9961,
    y1: 22.5,
    x2: 25.9961,
    y2: 22.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 169",
    x1: 21.9961,
    y1: 24.5,
    x2: 27.9961,
    y2: 24.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 170",
    x1: 21.9961,
    y1: 26.5,
    x2: 28.9961,
    y2: 26.5,
    stroke: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruiters);
export default __webpack_public_path__ + "static/media/Recruiters.fcb7e84f9b69b5d4680f2d44b265a467.svg";
export { ForwardRef as ReactComponent };